import * as React from 'react';
import { SVGProps } from 'react';

const CertificatesIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M13.656 8.072h8.75M26.781 13.177h-17.5M9.281 21.197h4.375M25.5 18.833a4.375 4.375 0 1 1-6.187 6.187 4.375 4.375 0 0 1 6.187-6.187Z" />
      <path d="M25.322 25.166v6.97l-2.917-1.459-2.917 1.458v-6.969" />
      <path d="M25.324 27.76H29.7a2.916 2.916 0 0 0 2.917-2.916V5.885a2.916 2.916 0 0 0-2.917-2.916H6.366a2.916 2.916 0 0 0-2.917 2.916v18.959a2.916 2.916 0 0 0 2.917 2.916H19.49" />
    </g>
  </svg>
);
export default CertificatesIcon;
